import { Button } from "@/components/ui/Button";
import type { PlanungFeinplanungRequestSummary } from "@/lib/montageplanung";

function formatRequestedAt(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function requesterLabel(request: PlanungFeinplanungRequestSummary): string {
  const display = request.employee_display?.trim();
  if (display && display.toLowerCase() !== request.employee_login.toLowerCase()) {
    return `${display} (${request.employee_login})`;
  }
  return display || request.employee_login;
}

export interface FeinplanungRequestApprovalCardProps {
  request: PlanungFeinplanungRequestSummary;
  onApprove: () => void;
  onReject: () => void;
  busy?: boolean;
  approving?: boolean;
  rejecting?: boolean;
}

export function FeinplanungRequestApprovalCard({
  request,
  onApprove,
  onReject,
  busy = false,
  approving = false,
  rejecting = false,
}: FeinplanungRequestApprovalCardProps) {
  const who = requesterLabel(request);

  return (
    <div className="rounded-ios-md border border-status-orange/35 bg-status-orange/10 px-3 py-3">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-status-orange">
        Offener Feinplanungs-Antrag
      </p>
      <p className="mt-1 text-sm font-semibold text-label">Freigabe für {who}</p>
      <p className="mt-1 text-xs leading-relaxed text-label-secondary">
        {who} möchte die Feinplanung für diesen Einsatz bearbeiten. Beantragt am{" "}
        {formatRequestedAt(request.requested_at)}.
      </p>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          loading={rejecting}
          disabled={busy}
          onClick={onReject}
        >
          Ablehnen
        </Button>
        <Button
          type="button"
          variant="primary"
          size="sm"
          loading={approving}
          disabled={busy}
          onClick={onApprove}
        >
          Freigeben
        </Button>
      </div>
    </div>
  );
}
